// Nav option impressions (NAV_OPTION_VIEWED / EXPERIENCE_LISTING_VIEWED) must count only exposures a
// person could actually see. Two things make an option "visible" to its IntersectionObserver when
// nobody can see it (plans/2026-09-23--nav-impressions-drawer-blind.md):
//
//   - The native drawer is SHUT. The nav webview stays laid out full-size behind it, so an observer
//     inside the webview can't tell the drawer's position. Programmatic pane switches (deep links,
//     experience reveals, the boot route restore) render panes while it is shut.
//   - The option's pane has LOST FOCUS. A blurred pane stays laid out for ~1s (`Pane#detach`) so its
//     slide-out can finish, and an entry already queued is still delivered after `unobserve()`.
//
// This file holds only the gate: MAY an impression be counted now? Whether an entry IS an exposure
// is decided by the shared `ExposureObserver` (app/javascript/rankers/helpers/exposure_observer.js,
// plans/2026-09-24--nav-tall-card-impressions.md), which each option component builds with this
// predicate as its `canCount` hook. An exposure the gate withholds is held there and counted by its
// `flush()`, which `Nav#flushPendingImpressions` triggers when the drawer opens. A withheld exposure
// from a pane that then blurs is discarded, because blurring stops the option's observer.
//
// Don't add a visibility or geometry rule here; the shared helper owns "is this entry an exposure?".

// May a nav impression be counted now? The option's pane must be the focused pane, and the nav must be
// open. Legacy-contract native apps (below the version floor, or native with an unknown version) own
// the drawer natively and never tell the webview it opened, so their `navOpen` is not authoritative:
// they keep today's behaviour (no drawer gate), or every nav impression on those apps would be lost.
export function canCountNavImpression(nav, pane) {
    if (pane && !pane.isFocused()) return false;
    if (!nav) return false;
    return nav.usesLegacyNavContract() || nav.readNavOpen();
}
